module.exports = __webpack_public_path__ + "static/img/c4.f787de4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c4.png
// module id = oMph
// module chunks = 1